/**
 * Adversarial Robustness game navigation registry.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { defineMonographNavigation } from "@csk/demo-ui/components/monograph-demo-shell";
import { DEMO_COLOR } from "@csk/demo-ui/design-system";
import { PlayPanel } from "../panels/PlayPanel.js";
import { ChallengePanel } from "../panels/ChallengePanel.js";
import { TheoremPanel } from "../panels/TheoremPanel.js";
import { MechanizationPanel } from "../panels/MechanizationPanel.js";

export const NAV = [
  {
    id: "play",
    label: "Red Team",
    subtitle: "Compromise k agents · try to breach the honest core",
    icon: "⚔",
    accent: DEMO_COLOR.danger,
    component: PlayPanel,
  },
  {
    id: "challenge",
    label: "How to Play",
    subtitle: "Your goal, the controls, and the honest thesis",
    icon: "◇",
    accent: DEMO_COLOR.gold,
    component: ChallengePanel,
  },
  {
    id: "theorem",
    label: "The Theorems",
    subtitle: "Isolation · confinement · bounded surface · k-resilience · BFT",
    icon: "Π",
    accent: DEMO_COLOR.sky,
    component: TheoremPanel,
  },
  {
    id: "mechanization",
    label: "Mechanization",
    subtitle:
      "Honest status: RD-31 is mechanized (--safe); two refinements open",
    icon: "λ",
    accent: DEMO_COLOR.teal,
    component: MechanizationPanel,
  },
] as const;

export const NAVIGATION = defineMonographNavigation(NAV, {
  defaultPanelId: "play",
});
